import Loader from '@lepass/components/utility/loader'
import {AuthAction, init} from 'next-firebase-auth'
import firebaseConfig from '../config/firebase.config'

const initAuth = () => {
  init({
    authPageURL: '/signin',
    appPageURL: '/dashboard',
    loginAPIEndpoint: '/api/login', // required
    logoutAPIEndpoint: '/api/logout', // required
    // No service account key file: uses Application Default Credentials.
    // - In prod (Cloud Functions): the runtime's attached service account.
    // - In local dev: your own identity from `gcloud auth application-default login`,
    //   which talks directly to the real prod project (le-pass-nc) — no emulator.
    useFirebaseAdminDefaultCredential: true,
    firebaseAdminInitConfig: {
      databaseURL: firebaseConfig.databaseURL,
      projectId: firebaseConfig.projectId,
      // Tells the SDK which service account to ask the IAM API to sign with
      // (createCustomToken/signBlob) instead of auto-discovering one via the
      // GCP metadata server, which doesn't exist outside GCP (i.e. locally).
      // Dedicated, least-privilege SA (Firestore + self signBlob only) — must
      // exist in IAM, and whoever runs this locally via
      // `gcloud auth application-default login` needs
      // roles/iam.serviceAccountTokenCreator on it.
      serviceAccountId: 'le-pass-server@le-pass-nc.iam.gserviceaccount.com',
    },
    firebaseClientInitConfig: firebaseConfig,
    cookies: {
      name: 'le-pass', // required
      // Keys are required unless you set `signed` to `false`.
      // The keys cannot be accessible on the client side.
      keys: [
        typeof window === 'undefined' ? 'Bw?+4g4Tb"G^rr6V' : undefined,
        typeof window === 'undefined' ? '>+w3rcUuQhN4Je7s' : undefined,
      ],
      httpOnly: true,
      maxAge: 2 * 60 * 60 * 24 * 1000, // 2 days
      overwrite: true,
      path: '/',
      sameSite: 'strict',
      secure: process.env.NODE_ENV === 'production', // set this to false in local (non-HTTPS) development
      signed: true,
    },
  })
}

export default initAuth

const protectedPageConfig = {
  ssr: {
    whenUnauthed: AuthAction.SHOW_LOADER,
  },
  default: {
    whenUnauthedBeforeInit: AuthAction.SHOW_LOADER,
    whenUnauthedAfterInit: AuthAction.REDIRECT_TO_LOGIN,
    LoaderComponent: Loader,
  }
}

const publicPageConfig = {
  ssr: {
    whenAuthed: AuthAction.SHOW_LOADER,
  },
  default: {
    whenAuthed: AuthAction.REDIRECT_TO_APP,
  }
}

export {publicPageConfig, protectedPageConfig}
